import Column from '../../../Column'
import Padding, { Sizes as PaddingSizes } from '../../../Padding'
import StoreAttribute from '../../../../types/StoreAttribute'
import AttributeKey from '../../../../types/AttributeKey'

interface StoreAttributesProps {
    attributes: StoreAttribute[]
}

function StoreAttributes({ attributes = [] }: StoreAttributesProps) {
    return (
        <>
            {attributes
                .filter(({ attributeKey }) => attributeKey !== AttributeKey.SecondaryStoreCode)
                .map(
                    ({ id, attributeKey, value }: StoreAttribute): JSX.Element => (
                        <Padding key={id} top size={PaddingSizes.xs}>
                            <Column>{attributeKey.replaceAll('_', ' ').toLowerCase()}</Column>
                            <Column>{value}</Column>
                        </Padding>
                    )
                )}
        </>
    )
}

export default StoreAttributes
